<template>
  <div class="menu_container">

    <el-menu style="margin-top: 50px" :collapse="isCollapse" :unique-opened="true" router :default-active="activeMenu">


      <el-submenu index="1" class="title">
        <template slot="title"><i class="el-icon-user"></i>用户管理</template>
        <el-menu-item-group>
          <el-menu-item index="/aichat/user_list">用户列表</el-menu-item>
          <el-menu-item index="/aichat/chat">对话历史</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="2" class="title">
        <template slot="title"><i class="el-icon-setting"></i>配置管理</template>
        <el-menu-item-group>
          <el-menu-item index="/aichat/openai_account">openai账号</el-menu-item>
          <el-menu-item index="/aichat/projectAdmin">项目配置</el-menu-item>
          <el-menu-item index="/aichat/commonProblem">常见问题</el-menu-item>
          <el-menu-item index="/aichat/page_pay_way">付款方式</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="3" class="title">
        <template slot="title"><i class="el-icon-s-claim"></i>营收管理</template>
        <el-menu-item-group>
          <el-menu-item index="/aichat/daily_data">收支情况</el-menu-item>
          <el-menu-item index="/aichat/ana">数据分析</el-menu-item>
        </el-menu-item-group>
      </el-submenu>



      <div>
        <div style="text-align: center;" class="ban"></div>
      </div>
      <div class="fl_cen" style="margin-top: 40px;">
      <div class="fold_btn" @click="toggleSidbar" >
        <i class="el-icon-s-fold icon_fold pointer"></i>
      </div>
    </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeMenu: ''
    };
  },
  created() {
    this.updateActiveMenu(this.$route);
  },
  methods: {
    toggleSidbar() {
      this.$emit("toggleSidbar");
    },
    updateActiveMenu(route) {
      // 处理带参数的 URL
      if (route.path.includes('/iframe') && route.query.url) {
        this.activeMenu = `/iframe?url=${route.query.url}`;
      } else {
        this.activeMenu = route.path;
      }
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.updateActiveMenu(route);
      },
      immediate: true
    }
  }
};
</script>
<style>
.el-submenu .el-menu-item {
  min-width: unset;
}

.el-menu {
  position: relative;
  border-right: 0;
}

.el-menu::-webkit-scrollbar {
  display: none;
}

.img {
  margin-right: 8px;
  padding-left: 5px;
  width: 16px;
}

.el-icon-fold {
  font-size: 18px;
}

.el-submenu__title {
  padding: 13px 20px 13px 24px;
  color: rgba(48, 49, 51, 1);
}

.el-submenu__icon-arrow {
  margin-top: -3px;
}

itle i {
  color: rgba(48, 49, 51, 1);
}

.el-menu-item.is-active {
  color: rgba(64, 158, 255, 1);
}

.fold_btn {
  right: 6px;
  width: 36px;
  height: 32px;
  border-radius: 4px;
  background: rgba(245, 247, 250, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.wd40 .fl_cen {
  margin-top: 10px;
  margin-right: 14px;
}

.wd40 .ban {
  display: none;
}
</style>
